<label for="values-{filterObject.id}">Wert</label>
<select id="values-{filterObject.id}" class="h-10 inline border border-gray-200 w-full p-2 rounded focus:outline-none invalid:bg-red-50 invalid:border-red-500" required
        on:change={(e) => { onUpdateFilter(filterObject, e.target.value) }}>
    <option value="">Bitte wählen</option>
    {#each filterObject.getDatasource() as option}
        <option selected={parseInt(filterObject.getValue()) === option.id} value="{option.id}">{option.name}</option>
    {/each}
</select>

{#if mounted && filterObject.getValue()}
    <ul class="mt-2">
        {#each filterObject.getValue().toString().split(",") as val}
            <li class="bg-green-drkn text-white p-0.5 border-b border-white flex justify-between px-2">
                {getValueObject(val).name}
                <button class="text-lg h-0" on:click={() => removeValue(filterObject, val)}>&times;</button>
            </li>
        {/each}
    </ul>
{/if}

<script>
    import {createEventDispatcher, onMount} from "svelte";

    const dispatch = createEventDispatcher();

    export let filterObject;

    let values = [];

    let filterValues = [];

    let mounted = false;

    onMount(() => {

        filterValues = filterObject.getValue().toString().split(",");

        filterValues.forEach(val => {
            onUpdateFilter(filterObject, val);
        });

        mounted = true;
    });

    function getValueObject(val) {
        return filterObject.getDatasource().find(char => {
            return char.id === parseInt(val);
        });
    }

    function onUpdateFilter(filterObject, value) {
        if (value === "" || values.includes(value)) return;

        filterObject.getDatasource();
        if (filterObject.getValue() === "") {
            values = [];
        }

        values = [...values, value];
        filterValues = values;
        dispatchUpdate(filterObject, values);
    }

    function removeValue(filterObject, val) {
        values = values.filter(value => {
            return value !== val;
        });
        filterValues = values;
        dispatchUpdate(filterObject, values)
    }

    function dispatchUpdate(filterObject, values) {
        dispatch("updateFilter", {
            filterObject,
            type: "values",
            value: values.join(",")
        });
    }

</script>